import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UserData, UserEntitlements } from '@ddv/entitlements';
import { Client, UserPreferences } from '@ddv/models';
import { FuzzyDate } from '@hs/ui-core-date';
import { Fund } from '@hs/ui-core-fund';
import { ModalDirective, ModalOptions } from '@hs/ui-core-layout';
import { IconComponent } from '@hs/ui-core-presentation';

import { UserPreferencesFormComponent } from './user-preferences-form/user-preferences-form.component';

@Component({
    selector: 'ddv-user-preferences',
    templateUrl: 'user-preference.component.html',
    styleUrls: ['user-preference.component.scss'],
    imports: [
        IconComponent,
        UserPreferencesFormComponent,
        ModalDirective,
    ],
})
export class UserPreferenceComponent implements AfterViewInit {
    @Input() clientCode: string | undefined;
    @Input() isMultiClient = false;
    @Input() user: UserData | undefined;
    @Input() userEntitlements: UserEntitlements | undefined;
    @Input() userPreferences: UserPreferences | undefined;
    @Input() funds: Fund[] = [];
    @Input() clients: Client[] | undefined;
    @Input() fuzzyDates: FuzzyDate[] | undefined;

    @Output() userPreferencesChange = new EventEmitter<UserPreferences>();

    protected showForm = false;
    protected modalOptions: ModalOptions = {};

    @ViewChild('icon', { static: false, read: ElementRef }) private readonly icon: ElementRef<HTMLElement> | undefined;

    ngAfterViewInit(): void {
        this.modalOptions = {
            anchorToElement: this.icon?.nativeElement,
            position: 'bottom-right',
        };
    }
}
